<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('absences.setting.create_absence_type')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeTypeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row">
              <div class="col-md-12">
                <Input
                  container-class="form-group mb-5"
                  :name="`name`"
                  type="text"
                  :label="$t('absences.setting.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :isRequired="false" 
                  v-model="formData.name"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeTypeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps} from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText.vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from 'vue-router';

const emits = defineEmits(['load'])

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  form: {
    type: Object,
    default: {
      id: '',
      name: ''
    }
  },
  edit: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const router = useRouter()
const route = useRoute()

const isLoading = ref(false)

const formData = ref(props.form)

function closeTypeModal(){
  $('#'+props.id).modal('toggle')
}

function submitForm(){
  isLoading.value = true
    if(!props.edit){
      store.dispatch('absence_types/createAbsenceType', formData.value)
        .then((response) => {
            isLoading.value = false
            emits('load', response?.data?.holiday_type?.id)
            closeTypeModal()
            formData.value.name = ''

            window.toastr['success'](i18n.global.t('absences.setting.absence_types_created_successfully'))
        })
        .catch(err => {
            isLoading.value = false
        })
    }else{
      store.dispatch('absence_types/updateAbsenceType', formData.value)
        .then((response) => {
            isLoading.value = false
            emits('load')
            closeTypeModal()
            formData.value.name = ''

            window.toastr['success'](i18n.global.t('absences.setting.absence_types_updated_successfully'))
        })
        .catch(err => {
            isLoading.value = false
        })
    }
}
</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}
</style>